export function redactAuthTokens(value: string): string {
  return value.replace(/((?:token_hash|access_token|refresh_token)=)[^&#\s"'<>]*/gi, '$1[REDACTED]');
}

export function redactAuthEventProperties(properties: object): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(properties).map(([key, value]) => [key, typeof value === 'string' ? redactAuthTokens(value) : value]),
  );
}
